"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconCalendar = function IconCalendar(_ref) {
  var className = _ref.className,
      color = _ref.color,
      size = _ref.size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 6a2 2 0 012 2v1h12V8a2 2 0 114 0v1h3.09c3.1 0 4.91 2.952 4.91 5.625v21.75C43 39.048 41.19 42 38.09 42H11.91C8.81 42 7 39.048 7 36.375v-21.75C7 11.952 8.81 9 11.91 9H15V8a2 2 0 012-2zm14 7v2a2 2 0 104 0v-2h3.09c.09 0 .279.04.498.313.223.278.412.735.412 1.312v4.103H11v-4.103c0-.577.19-1.034.412-1.312.22-.273.408-.313.497-.313H15v2a2 2 0 104 0v-2h12zm8 9.728v13.647c0 .577-.19 1.034-.412 1.312-.22.273-.408.313-.497.313H11.909c-.09 0-.278-.04-.497-.313-.223-.278-.412-.735-.412-1.312V22.728h28z",
    fill: color
  }));
};

IconCalendar.defaultProps = {
  color: 'black',
  size: 30
};
IconCalendar.propTypes = {
  color: _propTypes.string,
  className: _propTypes.string,
  size: _propTypes.number
};
var _default = IconCalendar;
exports.default = _default;